import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseSwitch.module.scss'

import MyhouseTooltipLayer, { TooltipPosition } from '@Components/atoms/MyhouseTooltipLayer'
import { handleNclickMix } from '@Helpers/nclick'

const cx = className.bind(style)

type Props = {
  description?: any
  isInit?: any
  setChecked?: any
  isTooltip?: any
  tipTitle?: any
  tipDescription?: any
  nclickChange?: string
  nclickTooltip?: string
}

const MyhouseSwitch: React.FC<Props> = ({ description, isInit, setChecked, isTooltip, tipTitle, tipDescription, nclickChange, nclickTooltip }: Props) => {
  return (
    <div className={cx('wrap')}>
      <span className={cx('title')}>
        {description}
        {isTooltip && <MyhouseTooltipLayer position={TooltipPosition.BOTTOM} title={tipTitle} description={tipDescription} nclickOpen={nclickTooltip} />}
      </span>
      <span className={cx('switch')}>
        <input id={`myhouse_input` + description} type="checkbox" className={cx('input')} checked={isInit} onChange={handleNclickMix(nclickChange, () => setChecked(!isInit))} />
        <label htmlFor={`myhouse_input` + description} className={cx('label')}>
          {/* check되었을 경우 text를 '선택 해제'로 변경 */}
          <span className="blind">선택</span>
        </label>
      </span>
    </div>
  )
}

export default MyhouseSwitch
